import { Image, Tag, Button, Space, Popover, Table } from "antd";

import { persianDateFormat } from "./function.helper";
import { Link } from "react-router-dom";
import { fallback } from "../constants/image.constant";

import {
  MinusOutlined,
  TransactionOutlined,
  LockOutlined,
  UnlockOutlined,
  RollbackOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";

export const columns = (handleConfirm?: any, handleConditionProduct?: any) => {
  return [
    {
      title: "#",
      dataIndex: "number",
      key: "number",
      width: "6%",
      
    },
    {
      title: "نام",
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: "تولید کننده",
      dataIndex: "manufacturerDisplayName",
      key: "manufacturerDisplayName",
      sorter: true,
    },
    {
      title: "انبار",
      dataIndex: "warehouseName",
      key: "warehouseName",
      sorter: false,
    },
    {
      title: "Sku",
      dataIndex: "sku",
      key: "sku",
      sorter: true,
      render: (source: any) =>
        source ? (
          <Link to={`/panel/sku?Sku=${source}`} style={{textDecoration:'underline blue',cursor:'pointer'}}>
            <span style={{textDecoration:'underline blue',cursor:'pointer'}}>{source} </span>
          </Link>
        ) : (
          <p style={{ color: "#c1c1c1" }}>---</p>
        ),
    },
    {
      title: "تعداد",
      dataIndex: "quantity",
      key: "quantity",
      width: "6%",
    },
    {
      title: "لینک سفارش",
      dataIndex: "reserveId",
      key: "reserveId",
      render: (source: any) =>
        source ? (
          <a
            href={
              "https://backoffice.aassttiinn.com/Admin/Order/Edit/" + source
            }
            target="_blank"
          >
            لینک سفارش
          </a>
        ) : (
          <p style={{ color: "#c1c1c1" }}>---</p>
        ),
    },
    {
      title: "تصویر",
      dataIndex: "imageUrl",
      key: "imageUrl",
      width: "6%",
      render: (source: any) => (
        <Image
          width={40}
          src={source ? source : ""}
          placeholder={<Image preview={false} src={source} width={200} />}
          fallback={fallback}
        />
      ),
    },
    {
      title: "آیا رزرو شده",
      dataIndex: "isReserved",
      key: "isReserved",
      width: "8%",
      render: (tags: boolean) => (
        <>
          {tags === true ? (
            <Tag color="#f50" key={0}>
              <b>بله</b>
            </Tag>
          ) : (
            <Tag color="#2db7f5" key={1}>
              خیر
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "تاریخ ایجاد",
      dataIndex: "creationTime",
      key: "creationTime",
      sorter: true,
    },
    {
      title: "عملیات",
      dataIndex: "actions",
      key: "actions",
      render: (source: any) => (
        <Space style={{ alignItems: "center" }}>
          <Popover content="وضعیت کلی محصول" trigger="hover">
            <Button
              type="primary"
              icon={<FileSearchOutlined />}
              style={{
                backgroundColor: "#34BE82",
                border: "none",
              }}
              onClick={() =>
                handleConditionProduct(source.stockKeepingUnit.name)
              }
            ></Button>
          </Popover>
          <Popover content="خروج از انبار" trigger="hover">
            <Link
              to={`/panel/product/exit/${source.id}?w=${source.warehouseId}&id=${source.skuId}`}
              state={{ details: source }}
              className="logo-normal"
              style={{
                backgroundColor: "#406882",
                border: "none",
                color: "white",
                padding: "4px 8px",
              }}
            >
              <MinusOutlined />
            </Link>
          </Popover>
          <Popover content={source.isLocked ? "باز" : "قفل"} trigger="hover">
            <Button
              type="primary"
              icon={source.isLocked ? <LockOutlined /> : <UnlockOutlined />}
              style={{
                backgroundColor: source.isLocked ? "#D82148" : "#34BE82",

                border: "none",
              }}
              onClick={() =>
                handleConfirm(source.isLocked, source.id, "lockProduct")
              }
            ></Button>
          </Popover>
          <Popover content="انتقال" trigger="hover">
            <Link
              to={`/panel/product/transfer/${source.id}?w=${source.warehouseId}`}
              state={{ details: source }}
              className="logo-normal"
              style={{
                backgroundColor: "#406882",
                border: "none",
                color: "white",
                padding: "4px 8px",
              }}
            >
              <TransactionOutlined />
            </Link>
          </Popover>
          <Popover content="بازشگت محصول" trigger="hover">
            <Button
              type="primary"
              icon={<RollbackOutlined />}
              style={{
                border: "none",
                backgroundColor:
                  source.isReturned === "False" ? "#8080807a" : "##ff7875",
                color: "white",
              }}
              disabled={source.isReturned === "False"}
              onClick={() =>
                handleConfirm(source.isLocked, source.id, "returnProduct")
              }
            />
          </Popover>
        </Space>
      ),
    },
    Table.EXPAND_COLUMN,
  ];
};

export const generalconditioncolumn = () => {
  return [
    {
      title: "#",
      dataIndex: "number",
      key: "number",
      width: "6%",
    },
    {
      title: "نام",
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: "تولید کننده",
      dataIndex: "manufacturerDisplayName",
      key: "manufacturerDisplayName",
      sorter: true,
    },
    {
      title: "انبار",
      dataIndex: "warehouseName",
      key: "warehouseName",
      sorter: false,
    },
    {
      title: "Sku",
      dataIndex: "sku",
      key: "sku",
      sorter: true,
    },
    {
      title: "تعداد",
      dataIndex: "quantity",
      key: "quantity",
      width: "6%",
    },
    {
      title: "لینک سفارش",
      dataIndex: "reserveId",
      key: "reserveId",
      render: (source: any) =>
        source ? (
          <a
            href={"https://aassttiinn.org/Admin/Order/Edit/" + source}
            target="_blank"
          >
            لینک سفارش
          </a>
        ) : (
          <p style={{ color: "#c1c1c1" }}>---</p>
        ),
    },
    {
      title: "تصویر",
      dataIndex: "imageUrl",
      key: "imageUrl",
      width: "6%",
      render: (source: any) => (
        <Image
          width={40}
          src={source ? source : ""}
          placeholder={<Image preview={false} src={source} width={200} />}
          fallback={fallback}
        />
      ),
    },
    {
      title: "آیا رزرو شده",
      dataIndex: "isReserved",
      key: "isReserved",
      width: "8%",
      render: (tags: boolean) => (
        <>
          {tags === true ? (
            <Tag color="green" key={0}>
              بله
            </Tag>
          ) : (
            <Tag color="red" key={1}>
              خیر
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "تاریخ ایجاد",
      dataIndex: "creationTime",
      key: "creationTime",
      sorter: true,
    },

    Table.EXPAND_COLUMN,
  ];
};
export const productdatahelper = (res: any, page: number) => {
  const newData = res.map((item: any, index: number) => {
    return {
      ...item,
      key: item.id,
      creationTime: persianDateFormat(item.creationTime),
      actions: item,
      imageUrl: item.stockKeepingUnit.imageUrl,
      number: index + 1 + 40 * (page - 1),
      sku: item.stockKeepingUnit.sku,
      name: item.stockKeepingUnit.name,
      manufacturerDisplayName: item.stockKeepingUnit.manufacturerDisplayName,
    };
  });
  return newData;
};

export const productdatahelperSingle = (item: any) => {
  return {
    ...item,
    key: item.id,
    creationTime: persianDateFormat(item.creationTime),
    actions: item,
    imageUrl: item.stockKeepingUnit.imageUrl,
    sku: item.stockKeepingUnit.sku,
    name: item.stockKeepingUnit.name,
    manufacturerDisplayName: item.stockKeepingUnit.manufacturerDisplayName,
  };
};

export const handleExitParams = (
  skuId: string | null,
  type: string,
  quantity: string,
  warehouseId: string | null
) => {
  return {
    skuId: Number(skuId),
    type,
    quantity,
    reserveId: null,
    warehouseId,
  };
};

export const handleTransferParams = (
  productId: string,
  quantity: string,
  fromWarehouse: string | null,
  toWarehouse: string
) => {
  return {
    productId: productId,
    quantity,
    fromWarehouse: Number(fromWarehouse),
    toWarehouse,
  };
};
